/*
 * Srovnávací tabulka — na mobilu slider po jednom sloupci (noži) se šipkami.
 * Na desktopu se nepoužije (CSS ukazuje všechny sloupce); JS jen udržuje
 * aktivní sloupec (.cmp-active), který mobilní CSS zobrazí, ostatní skryje.
 * Kontejner: .comparison, hlavičky: .comparison__head, řádky: .comparison__row
 * (buňky .comparison__cell), ovládání: [data-cmp-prev/next/dots].
 */
(function () {
  if (window.__saracenComparison) return;
  window.__saracenComparison = true;

  function setup(root) {
    if (root.dataset.cmpReady) return;
    root.dataset.cmpReady = '1';

    var heads = Array.prototype.slice.call(root.querySelectorAll('.comparison__head-row > .comparison__head'));
    var cols = heads.length;
    if (cols < 2) return; // 1 sloupec = není co posouvat

    var rows = Array.prototype.slice.call(root.querySelectorAll('.comparison__row'));
    var prev = root.querySelector('[data-cmp-prev]');
    var next = root.querySelector('[data-cmp-next]');
    var dotsWrap = root.querySelector('[data-cmp-dots]');
    var active = 0;

    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      for (var i = 0; i < cols; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'comparison__dot';
        var slideLabel = root.getAttribute('data-cmp-slide-label');
        dot.setAttribute('aria-label', slideLabel ? slideLabel.replace('__INDEX__', String(i + 1)) : heads[i].textContent.trim());
        (function (idx) {
          dot.addEventListener('click', function () { active = idx; render(); });
        })(i);
        dotsWrap.appendChild(dot);
      }
    }

    function render() {
      for (var i = 0; i < heads.length; i++) {
        heads[i].classList.toggle('cmp-active', i === active);
      }
      rows.forEach(function (r) {
        var cells = r.querySelectorAll(':scope > .comparison__cell');
        for (var j = 0; j < cells.length; j++) {
          cells[j].classList.toggle('cmp-active', j === active);
        }
      });
      if (dotsWrap) {
        for (var d = 0; d < dotsWrap.children.length; d++) {
          dotsWrap.children[d].classList.toggle('is-active', d === active);
        }
      }
    }

    if (prev) prev.addEventListener('click', function () { active = (active - 1 + cols) % cols; render(); });
    if (next) next.addEventListener('click', function () { active = (active + 1) % cols; render(); });

    render();
  }

  /*
   * Na mobilu roztáhnout na celou šířku obrazovky i když je uvnitř užšího
   * kontejneru (blok na stránce produktu). Měříme SKUTEČNOU pozici (ne 50vw
   * trik, který předpokládá vycentrování) → funguje i mimo střed.
   */
  function fullBleed(root) {
    var inner = root.querySelector('.comparison__inner');
    if (!inner) return;
    var mobile = window.innerWidth < 750;

    // reset (kvůli měření i pro desktop)
    inner.style.marginLeft = '';
    inner.style.marginRight = '';
    inner.style.width = '';
    inner.style.maxWidth = '';
    inner.style.paddingLeft = '';
    inner.style.paddingRight = '';

    if (!mobile) return;

    var left = inner.getBoundingClientRect().left;
    inner.style.marginLeft = -left + 'px';
    inner.style.width = window.innerWidth + 'px';
    inner.style.maxWidth = 'none';
    inner.style.paddingLeft = '12px';
    inner.style.paddingRight = '12px';
  }

  function init(scope) {
    (scope || document).querySelectorAll('.comparison').forEach(function (root) {
      setup(root);
      fullBleed(root);
    });
  }

  var rt = null;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () {
      document.querySelectorAll('.comparison').forEach(fullBleed);
    }, 150);
  });

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
